import React from 'react';
import Questionnaires from '../../components/Questionnaires/Questionnaires';

const CompanyQuestionnairePage = () => {
  return <Questionnaires />;
};

export default CompanyQuestionnairePage;
